import Smartphones from './containers/Smartphones'
import Tablets from './containers/Tablets'

import { getCurrentDeviceView } from '../../../../shared/helpers/utils'

const MarketPlaceView = getCurrentDeviceView(Smartphones, Tablets)

export default MarketPlaceView
